module.exports = __webpack_public_path__ + "static/media/bannerBlackFriday10Mob.24a9550d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blackfriday/bannerBlackFriday10Mob.png
// module id = 205
// module chunks = 0